var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { SensitiveWordService } from "~/services/manage-service/sensitive-word.service";
import SvgIcon from "~/components/common/svg-icon.vue";
var WordsConfiguration = /** @class */ (function (_super) {
    __extends(WordsConfiguration, _super);
    function WordsConfiguration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 提示词
        _this.promptWord = "";
        // 严重词
        _this.seriousWord = "";
        _this.loading = {
            state: false
        };
        _this.model = {
            id: "",
            principalId: "",
            principalName: "",
            promptWords: [],
            seriousWords: []
        };
        return _this;
    }
    WordsConfiguration.prototype.emitClose = function () {
        // this.onIdChange(this.id)
    };
    WordsConfiguration.prototype.emitSuccess = function () { };
    WordsConfiguration.prototype.refreshData = function (data) {
        this.model = data;
    };
    // 词汇添加
    WordsConfiguration.prototype.appendClick = function (type) {
        if (type === 1) {
            if (!this.promptWord || this.promptWord.trim() === "") {
                this.promptWord = "";
                this.$message("提示词为空");
                return;
            }
            if (this.model.promptWords.includes(this.promptWord)) {
                this.$message("已存在该词条");
                return;
            }
            this.model.promptWords.push(this.promptWord);
            this.promptWord = "";
        }
        if (type === 2) {
            if (!this.seriousWord || this.seriousWord.trim() === "") {
                this.seriousWord = "";
                this.$message("严重词为空");
                return;
            }
            if (this.model.seriousWords.includes(this.seriousWord)) {
                this.$message("已存在该词条");
                return;
            }
            this.model.seriousWords.push(this.seriousWord);
            this.seriousWord = "";
        }
    };
    WordsConfiguration.prototype.submit = function () {
        var _this = this;
        if (this.model.promptWords.length == 0 && this.model.seriousWords.length == 0) {
            this.$message.warning("提示词与敏感词都为空，请输入要设置的信息");
            return;
        }
        this.loading.state = true;
        this.sensitiveWordService.modifySensitiveWord(this.model, this.loading).subscribe(function (data) {
            _this.$message.success("操作成功");
            _this.emitSuccess();
            _this.emitClose();
        });
    };
    WordsConfiguration.prototype.removeTag = function (data, flag) {
        if (flag === 0) {
            var index = this.model.promptWords.indexOf(data);
            if (index > -1) {
                this.model.promptWords.splice(index, 1);
            }
        }
        else {
            var index = this.model.seriousWords.indexOf(data);
            if (index > -1) {
                this.model.seriousWords.splice(index, 1);
            }
        }
    };
    __decorate([
        Dependencies(SensitiveWordService)
    ], WordsConfiguration.prototype, "sensitiveWordService", void 0);
    __decorate([
        Emit("close")
    ], WordsConfiguration.prototype, "emitClose", null);
    __decorate([
        Emit('success')
    ], WordsConfiguration.prototype, "emitSuccess", null);
    WordsConfiguration = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                SvgIcon: SvgIcon
            }
        })
    ], WordsConfiguration);
    return WordsConfiguration;
}(Vue));
export default WordsConfiguration;
